/**
 * @module  experience/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, Input, OnDestroy, EventEmitter } from '@angular/core';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';

@Component({
  selector: 'tmo-payment-disclaimer-modal',
  templateUrl: './payment-disclaimer-modal.component.html',
})
export class PaymentDisclaimerModalComponent implements OnDestroy {
  /**
   * Configurable AEM data from parent component
   */
  @Input() public configurableAemData: ConfigData;

  /**
   * To open the payment disclaimer modal
   */
  public paymentDisclaimerModal: DynamicModal;

  @Input() public modalText?: string;
  @Input() public modalHeading?: string;
  @Input() public isAccountClosed: boolean;
  @Input() public isCancelledAccount: boolean;
  @Input() public routeId: string;

  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.paymentDisclaimerModal = {
      disableDismiss: true,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'payment-disclaimer-modal',
    };
  }

  /**
   * closePaymentDisclaimerModal to close payment decline modal
   * @returns void
   */
  public closePaymentDisclaimerModal(): void {
    this.paymentDisclaimerModal.toggleModalEmitter.emit({ open: false, close: true });
  }

  /**
   * Method to open disclaimer Modal
   * @param {EventEmitter<Object>} [event]
   * @returns void
   */
  public openModal(): void {
    this.paymentDisclaimerModal.toggleModalEmitter.emit({ open: true, close: false });
  }

  public redirectTo(): void {
    if (this.isCancelledAccount) {
      this.router.navigate(['/resume-cancellation/select-line']);
    } else if (this.routeId === 'redeem-card') {
      this.router.navigate(['/refill-account/redeem']);
    } else if (this.routeId === 'auto-pay') {
      this.router.navigate(['/autopay']);
    } else if (this.routeId === 'one-time-payment' || this.routeId === 'Make a payment') {
      this.router.navigate(['/one-time-payment']);
    }
  }

  /**
   * Method to destroy data.
   * @returns void
   */
  public ngOnDestroy(): void {}
}
